// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"b18dcb88","545":"e3cf4123"}[chunkId] + ".chunk.js";
};